import { render } from "./SubsectionComponent.vue?vue&type=template&id=109781c8"
import script from "./SubsectionComponent.vue?vue&type=script&lang=js"
export * from "./SubsectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__